import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../core/common/selfLoder";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";



const LeaveGrid = [
  {
    name: "Attendance Calender",
    logo: "../assets/img/attendance/Team/team_attendance_calender.png",
    Link: "/team-attendance-calender",
  },
  {
    name: "Attendance History",
    logo: "../assets/img/attendance/Team/team_attendance_history.png",
    Link: "/team-attendance-history",
  },
  {
    name: "Team Regularization",
    logo: "../assets/img/attendance/Team/team_attendance_regularization.png",
    Link: "/team-attendance-regularization",
  },
];

const AttendanceTeamDashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Work & Operations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item">Team Attendance</li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Team Attendance</h5>
            </div>
            <div className="card-body">
              <div className="row h-100">
                {LeaveGrid.map((card, index) => (
                  <div
                    key={index}
                    className="col-6 col-sm-4 col-md-3 mb-4 d-flex"
                  >
                    <Link to={card.Link} className="w-100">
                      <div className="card h-100 shadow-sm px-2 py-3 px-md-4 px-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                        />
                        <h5 className="mb-0">{card.name}</h5>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default AttendanceTeamDashboard;
